import {useEmployeeNotificationState} from "app/employee/state/notification/mutations";

export const useNotificationLastRefresh = () => useEmployeeNotificationState((state) => state.refreshCount);
